import type React from 'react';
import type { AnyEntryPoint } from '@atlassian/entry-point-types';
import { ToolbarWrapper as ToolbarWrapperOld } from '@atlassian/jira-floating-toolbar/src/ui/toolbar-wrapper/index.tsx';
import {
	type FloatingToolbarProps,
	FloatingToolbar as FloatingToolbarNew,
	ToolbarWrapper as ToolbarWrapperNew,
	ToolbarSkeleton as ToolbarSkeletonNew,
	ContentSlider as ContentSliderNew,
} from '@atlassian/platform-floating-toolbar';
import { componentWithCondition } from '@atlassian/jira-feature-flagging-utils/src/utils/component-with-condition/index.tsx';
import { fg } from '@atlassian/jira-feature-gating';
import { ToolbarSkeleton as ToolbarSkeletonOld } from '@atlassian/jira-floating-toolbar/src/ui/skeleton/index.tsx';
import { ContentSlider as ContentSliderOld } from '@atlassian/jira-floating-toolbar/src/common/ui/index.tsx';
import { FloatingToolbar as FloatingToolbarOld } from '@atlassian/jira-floating-toolbar/src/ui/index.tsx';

export const FloatingToolbar: React.FC<
	FloatingToolbarProps<undefined> & FloatingToolbarProps<AnyEntryPoint | undefined>
> = componentWithCondition(
	() => fg('migrate_to_platform_bulk_toolbar'),
	FloatingToolbarNew,
	FloatingToolbarOld,
);

export const ToolbarWrapper = componentWithCondition(
	() => fg('migrate_to_platform_bulk_toolbar'),
	ToolbarWrapperNew,
	ToolbarWrapperOld,
);

export const ToolbarSkeleton = componentWithCondition(
	() => fg('migrate_to_platform_bulk_toolbar'),
	ToolbarSkeletonNew,
	ToolbarSkeletonOld,
);

export const ContentSlider = componentWithCondition(
	() => fg('migrate_to_platform_bulk_toolbar'),
	ContentSliderNew,
	ContentSliderOld,
);
